import type { PaletteBody } from '@library/types'

export function createTextureBuffer(
  renderingContext: WebGL2RenderingContext,
  imageWidth: number,
  imageHeight: number,
  imageData: Float32Array,
) {
  const texture = renderingContext.createTexture()
  renderingContext.activeTexture(renderingContext.TEXTURE0)
  renderingContext.bindTexture(renderingContext.TEXTURE_2D, texture)

  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_S,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_T,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MIN_FILTER,
    renderingContext.NEAREST,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MAG_FILTER,
    renderingContext.NEAREST,
  )

  /*  т.к. исходными данными для визуализации являются замеры с типом значений
   *  float32, а не цвета, то при передаче в шейдер необходимо это указать
   *  renderingContext.FLOAT - формат хранения исходных данных
   *  renderingContext.R32F  - формат, в котором будет читать данные GPU
   *  renderingContext.RED   - указание, что 32 бита будут записаны в R канал
   */

  renderingContext.texImage2D(
    renderingContext.TEXTURE_2D,
    0,
    renderingContext.R32F,
    imageWidth,
    imageHeight,
    0,
    renderingContext.RED,
    renderingContext.FLOAT,
    imageData,
  )
  return texture
}

export function createPaletteTexture(
  renderingContext: WebGL2RenderingContext,
  palette: PaletteBody,
) {
  const texture = renderingContext.createTexture()
  renderingContext.activeTexture(renderingContext.TEXTURE1)
  renderingContext.bindTexture(renderingContext.TEXTURE_2D, texture)

  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_S,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_WRAP_T,
    renderingContext.CLAMP_TO_EDGE,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MIN_FILTER,
    renderingContext.NEAREST,
  )
  renderingContext.texParameteri(
    renderingContext.TEXTURE_2D,
    renderingContext.TEXTURE_MAG_FILTER,
    renderingContext.NEAREST,
  )

  /*  renderingContext.UNSIGNED_BYTE - тип предоставляемых данных
   *  renderingContext.RGBA8         - формат, в котором будет читать данные GPU
   *  renderingContext.RGBA          - формат предоставляемых данных
   */
  renderingContext.texImage2D(
    renderingContext.TEXTURE_2D,
    0,
    renderingContext.RGBA8,
    1,
    palette.length / 4,
    0,
    renderingContext.RGBA,
    renderingContext.UNSIGNED_BYTE,
    new Uint8Array(palette),
  )
  return texture
}

export function booleanToNumber(value: boolean): 0 | 1 {
  return value ? 1 : 0
}
